import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedMentionView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'mentions'
  hasLogicSelector: true

  getDescription: (value) ->
    return "@#{value}"

  removeFilter: (value) ->
    @searchQuery.removeMention(value)